// extracted by mini-css-extract-plugin
module.exports = {"group":"group--TAFzI","button":"button--nJiry","icon":"icon--NGFZm"};